module.exports = __webpack_public_path__ + "87a2222f032cd44452302bc7144b826d.svg";